var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v(" © 2020 Copyright: "),_c('a',{attrs:{"href":"http://www.morganfamilytrust.net/"}},[_vm._v(" Morgan Family Trust ")])])
}]

export { render, staticRenderFns }